var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.759 3.07812L11.7389 14.7023H4.26043L3.24055 3.07812L1.94824 3.19141L2.98674 15.0264C3.0414 15.5719 3.51471 15.9996 4.06455 15.9996H11.9348C12.4845 15.9996 12.958 15.5721 13.0135 15.0186L14.0514 3.19141L12.759 3.07812Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3789 0H5.62211C5.02598 0 4.54102 0.484969 4.54102 1.08109V3.13516H5.8383V1.29728H10.1626V3.13512H11.4599V1.08106C11.46 0.484969 10.975 0 10.3789 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9191 2.48633H1.08127C0.722992 2.48633 0.432617 2.7767 0.432617 3.13498C0.432617 3.49327 0.722992 3.78364 1.08127 3.78364H14.9191C15.2774 3.78364 15.5678 3.49327 15.5678 3.13498C15.5678 2.7767 15.2774 2.48633 14.9191 2.48633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconPopup);
export default __webpack_public_path__ + "static/media/deleteIconPopup.7b4059ca00bb92f85a39fc1bac4e8416.svg";
export { ForwardRef as ReactComponent };